import React from 'react';
import Dashboard from '../../components/Dashboard';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function DashboardPage() {
  return (
    <AppLayout
      title="Dashboard"
      subtitle="Métricas e visão executiva"
      fullWidth
    >
      <Dashboard />
    </AppLayout>
  );
}

export default DashboardPage;
